/* ===== Cenzio — set indirimi (Bundle & save) =====
   Oranlar snippets/cz-offer.liquid'den gelir (window.CzOffer.tiers).
   1) Ortak yardimcilar: pct(n), msg(n), bar(), update(el, n)
      — set bolumu (cz-bundle.js) de bunlari kullanir.
   2) Sepet cekmecesi ve sepet sayfasina kademe cubugu:
      "1 tane daha ekle, %25 indirim" / "%40 uygulandi".
      Cekmece her guncellemede yeniden basildigi icin cubuk bir
      MutationObserver ile geri konur; adet /cart.js'ten okunur.
   Indirimi uygulayan Shopify'in otomatik indirimleri; burasi yalnizca gosterir.
   3) Sepet satirlarindaki olcu yazisi ve 'Color' -> 'Frame color'; olcu: '9" x 12" (Vertical)' -> '9″ × 12″'
      (urun sayfasi ve set bolumuyle ayni bicim). Yalnizca ekranda; odeme
      sayfasi ve e-postalar urun verisindeki ham degeri gostermeye devam eder.
   4) Hediye notu: sepet cekmecesi ve sepet sayfasinda "Sending it as a gift?"
      kutusu. Yazilan not sepet notu (cart note) olarak kaydedilir; sipariste
      Shopify admin > Notes alaninda gorunur, Printify'da gift note olarak girilir.
   ============================================================ */
(function () {
  'use strict';
  var C = window.CzOffer;
  if (!C || !C.tiers || !C.tiers.length || C.ready) return;
  C.ready = true;
  var T = C.tiers.slice().sort(function (a, b) { return a.n - b.n; });
  var last = T[T.length - 1];

  function plural(k) { return k === 1 ? 'print' : 'prints'; }

  C.pct = function (n) {
    var p = 0;
    T.forEach(function (t) { if (n >= t.n) p = t.p; });
    return p;
  };

  C.msg = function (n, verb) {
    verb = verb || 'applied';
    var nx = null;
    for (var i = 0; i < T.length; i++) { if (n < T[i].n) { nx = T[i]; break; } }
    var cur = C.pct(n);
    if (n <= 0) return 'Choose ' + T[0].n + ' prints to unlock <strong>' + T[0].p + '% off</strong>';
    if (!nx) return '<strong>' + cur + '% off</strong> ' + verb + ' &mdash; our best bundle price';
    var k = nx.n - n;
    if (!cur) return 'Add ' + k + ' more ' + plural(k) + ' to unlock <strong>' + nx.p + '% off</strong>';
    return '<strong>' + cur + '% off</strong> ' + verb + ' &middot; add ' + k + ' more for <strong>' + nx.p + '% off</strong>';
  };

  /* Kademe kartlari: 1 print (Full price) · 2 prints (25% off) · 3+ prints (40% off).
     Adet bir kademeye ulasinca kartin ust cizgisi yanar (is-on);
     ulasilan en yuksek indirimli kademe vurgulanir (is-cur). */
  var steps = [1].concat(T.map(function (t) { return t.n; }));

  C.bar = function () {
    var d = document.createElement('div');
    d.className = 'cz-offer-bar';
    d.setAttribute('data-cz-offer', '');
    var html = '<ol class="cz-offer-bar__tiers" aria-hidden="true">';
    steps.forEach(function (s, i) {
      var t = i ? T[i - 1] : null;
      var q = s + (t === last ? '+' : '') + ' ' + plural(s);
      var v = t ? t.p + '%<i>off</i>' : 'Full price';
      html += '<li class="cz-offer-bar__t"><span class="cz-offer-bar__q">' + q + '</span>' +
        '<span class="cz-offer-bar__v' + (t ? '' : ' cz-offer-bar__v--base') + '">' + v + '</span></li>';
    });
    d.innerHTML = html + '</ol><p class="cz-offer-bar__msg" aria-live="polite"></p>';
    return d;
  };

  C.update = function (el, n, verb) {
    var m = el.querySelector('.cz-offer-bar__msg');
    var h = C.msg(n, verb);
    if (m && m.innerHTML !== h) m.innerHTML = h;
    var lis = [].slice.call(el.querySelectorAll('.cz-offer-bar__t')), cur = -1;
    lis.forEach(function (li, i) {
      var on = n >= steps[i];
      li.classList.toggle('is-on', on);
      if (on) cur = i;
    });
    lis.forEach(function (li, i) { li.classList.toggle('is-cur', i === cur && i > 0); });
  };

  /* ---------- sepet satirlarinda olcu yazisi ---------- */
  var RX_ORIENT = /\s*\((vertical|horizontal|portrait|landscape|square)\)\s*/i;
  function tidy(root) {
    if (!root || !root.querySelectorAll) return;
    /* "Color:" -> "Frame color:" (urun sayfasiyla ayni ad) */
    [].slice.call(root.querySelectorAll('.product-option dt')).forEach(function (dt) {
      if (!/^\s*colou?r\s*:?\s*$/i.test(dt.textContent)) return;
      dt.setAttribute('data-cz-tidy', '');
      dt.textContent = 'Frame color: ';
    });
    [].slice.call(root.querySelectorAll('.product-option dd')).forEach(function (dd) {
      var t = dd.textContent;
      if (!RX_ORIENT.test(t)) return;
      t = t.replace(RX_ORIENT, ' ').trim();
      if (/^\d+(\.\d+)?\s*["″”]?\s*[x×]\s*\d/i.test(t)) {
        t = t.replace(/["″”]/g, '″').replace(/\s*[x×]\s*/i, ' × ');
      }
      dd.setAttribute('data-cz-tidy', '');
      dd.textContent = t;
    });
  }
  C.tidy = tidy;

  /* ---------- sepet cekmecesi + sepet sayfasi ---------- */
  var spots = [
    '#CartDrawer .drawer__header',
    'cart-items .title-wrapper-with-link'
  ];
  var count = null, timer = null, note = '';

  /* ---------- hediye notu ---------- */
  var giftSpots = [
    '#CartDrawer .drawer__footer > .cart__ctas',
    '#main-cart-footer .cart__blocks > .cart__ctas'
  ];
  var GIFT_MAX = 240, saveT = null;
  var ICON = '<svg class="cz-gift__ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="9" width="17" height="11.5" rx="1"/><path d="M2.5 9h19M12 9v11.5M12 9c-1.6-3.4-5.8-4.2-5.8-1.6C6.2 9 12 9 12 9Zm0 0c1.6-3.4 5.8-4.2 5.8-1.6C17.8 9 12 9 12 9Z"/></svg>';

  function giftBox() {
    var d = document.createElement('details');
    d.className = 'cz-gift';
    d.setAttribute('data-cz-gift', '');
    d.innerHTML =
      '<summary>' + ICON + '<span class="cz-gift__t">Sending it as a gift?</span>' +
      '<span class="cz-gift__a">Add a note</span></summary>' +
      '<div class="cz-gift__body">' +
        '<label class="visually-hidden" for="">Gift note</label>' +
        '<textarea maxlength="' + GIFT_MAX + '" rows="3" placeholder="Write your message — we’ll include it with the package."></textarea>' +
        '<p class="cz-gift__meta"><span data-state>Saved with your order</span><span data-count></span></p>' +
      '</div>';
    var ta = d.querySelector('textarea');
    var id = 'CzGift-' + Math.random().toString(36).slice(2, 8);
    ta.id = id; d.querySelector('label').setAttribute('for', id);
    ta.value = note;
    if (note) d.open = true;
    var st = d.querySelector('[data-state]'), cnt = d.querySelector('[data-count]');
    function counter() { cnt.textContent = ta.value.length + ' / ' + GIFT_MAX; }
    counter();
    ta.addEventListener('input', function () {
      counter();
      st.textContent = 'Saving…';
      clearTimeout(saveT);
      saveT = setTimeout(function () { saveNote(ta.value, st); }, 600);
    });
    ta.addEventListener('blur', function () {
      if (ta.value !== note) { clearTimeout(saveT); saveNote(ta.value, st); }
    });
    return d;
  }

  function saveNote(v, st) {
    v = String(v || '').slice(0, GIFT_MAX);
    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: v })
    }).then(function (r) { return r.json(); }).then(function (c) {
      note = c.note || '';
      if (st) st.textContent = note ? 'Saved — we’ll include it' : 'Saved with your order';
      /* Diger kopyayi (cekmece / sayfa) esitle */
      [].slice.call(document.querySelectorAll('[data-cz-gift] textarea')).forEach(function (t) {
        if (t !== document.activeElement) t.value = note;
      });
    }).catch(function () { if (st) st.textContent = 'Could not save — please try again'; });
  }

  function placeGift() {
    giftSpots.forEach(function (sel) {
      var a = document.querySelector(sel);
      if (!a) return;
      var el = a.previousElementSibling;
      if (!el || !el.hasAttribute('data-cz-gift')) {
        el = giftBox();
        a.parentNode.insertBefore(el, a);
      }
      el.hidden = !count;
    });
  }

  function place() {
    spots.forEach(function (sel) {
      var a = document.querySelector(sel);
      if (!a) return;
      var el = a.nextElementSibling;
      if (!el || !el.hasAttribute('data-cz-offer')) {
        el = C.bar();
        a.insertAdjacentElement('afterend', el);
      }
      el.hidden = !count;
      if (count) C.update(el, count);
    });
  }

  function load() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        /* Hediye karti set indirimine girmez (Shopify indirimleri gift card'a uygulamaz);
           sayaca da girmesin, yoksa "25% applied" yazip uygulanmazdi. */
        count = (c.items || []).reduce(function (n, i) { return i.gift_card ? n : n + i.quantity; }, 0);
        note = c.note || ''; place(); placeGift(); })
      .catch(function () {});
  }

  function kick() { clearTimeout(timer); timer = setTimeout(load, 120); }

  function watch() {
    var mo = new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var tg = ms[i].target;
        if (tg.nodeType !== 1) tg = tg.parentElement;
        if (tg && tg.closest && tg.closest('[data-cz-offer], [data-cz-tidy], [data-cz-gift]')) continue;
        tidy(document.querySelector('cart-drawer'));
        tidy(document.querySelector('cart-items'));
        kick();
        return;
      }
    });
    ['cart-drawer', '#main-cart-items', 'cart-items', '#main-cart-footer'].forEach(function (sel) {
      var n = document.querySelector(sel);
      if (n) mo.observe(n, { childList: true, subtree: true });
    });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, kick); } catch (e) {}
    }
    tidy(document.querySelector('cart-drawer'));
    tidy(document.querySelector('cart-items'));
    load();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
